import React from 'react';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/usersStyle';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { BodyS, Caption } from 'components/Typography/Typography';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IConfirmationDialogBodyProps {
	allSelected: boolean;
}

const ConfirmationDialogBody = ({ allSelected = false }: IConfirmationDialogBodyProps) => {
	const classes = useStyles();

	return (
		<div>
			{allSelected ? (
				<>
					<BodyS>{translate('users.are.you.sure.you.want.delete.all.users')}</BodyS>
					<BodyS>{translate('users.numbers.wont.be.assigned')}</BodyS>
					<div className={classes.warning}>
						<Caption color={'danger'}>{translate('users.your.account.wont.be.deleted')}</Caption>
					</div>
				</>
			) : (
				<BodyS>{translate('users.are.you.sure.you.want.delete.selected.users')}</BodyS>
			)}
		</div>
	);
};

export default ConfirmationDialogBody;
